import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const PLAN_COLORS = {
  trial: { bg: '#fef3c7', text: '#92400e', label: 'Deneme' },
  starter: { bg: '#dbeafe', text: '#1e40af', label: 'Starter' },
  pro: { bg: '#dcfce7', text: '#166534', label: 'Pro' },
  TRIAL: { bg: '#fef3c7', text: '#92400e', label: 'Deneme' },
  STARTER: { bg: '#dbeafe', text: '#1e40af', label: 'Starter' },
  PRO: { bg: '#dcfce7', text: '#166534', label: 'Pro' },
};

const STATUS_LABELS = {
  trial: { text: 'Deneme', color: '#f59e0b' },
  active: { text: 'Aktif', color: '#10b981' },
  expired: { text: 'Süresi Doldu', color: '#ef4444' },
  frozen: { text: 'Donduruldu', color: '#94a3b8' },
};

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [actioning, setActioning] = useState(null);
  const navigate = useNavigate();

  const quickAction = async (e, customerId, action) => {
    e.stopPropagation();
    setActioning(customerId + action);
    try {
      if (action === 'freeze') {
        const c = customers.find(x => x.id === customerId);
        const newStatus = c.status === 'frozen' ? 'active' : 'frozen';
        await api.patch(`/admin/customers/${customerId}/plan`, { status: newStatus });
        setCustomers(prev => prev.map(x => x.id === customerId ? { ...x, status: newStatus } : x));
      } else if (action === 'extend') {
        await api.patch(`/admin/customers/${customerId}/plan`, { status: 'trial' });
      }
    } catch {
      /* sessiz */
    } finally {
      setActioning(null);
    }
  };

  useEffect(() => {
    api.get('/admin/customers')
      .then(d => setCustomers(d.customers || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtered = customers.filter(c =>
    !search || c.name?.toLowerCase().includes(search.toLowerCase()) || c.email?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div style={{ padding: 40, color: '#64748b' }}>Yükleniyor...</div>;

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>Müşteriler</h1>
      <p style={{ color: '#64748b', marginBottom: 20, fontSize: 14 }}>{customers.length} otel kayıtlı</p>

      <input
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Otel adı veya e-posta ara..."
        style={{
          marginBottom: 20, padding: '10px 16px', borderRadius: 8,
          border: '1px solid #e2e8f0', fontSize: 14, width: 320, outline: 'none',
        }}
      />

      <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              {['Otel', 'Plan', 'Durum', 'Kanallar', 'Bu Ay Mesaj', 'Bu Ay Rez.', 'Kayıt Tarihi', 'Aksiyonlar'].map(h => (
                <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 12, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map(c => {
              const planStyle = PLAN_COLORS[c.plan] || { bg: '#f1f5f9', text: '#475569', label: c.plan };
              const statusStyle = STATUS_LABELS[c.status] || { text: c.status, color: '#94a3b8' };
              return (
                <tr
                  key={c.id}
                  onClick={() => navigate(`/admin/customers/${c.id}`)}
                  style={{ cursor: 'pointer', transition: 'background 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}
                >
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9' }}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#1e293b' }}>{c.name}</div>
                    {c.email && <div style={{ fontSize: 12, color: '#94a3b8' }}>{c.email}</div>}
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9' }}>
                    <span style={{
                      fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                      background: planStyle.bg, color: planStyle.text,
                    }}>{planStyle.label}</span>
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9' }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: statusStyle.color }}>
                      {statusStyle.text}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {c.whatsappConnected && (
                        <span style={{ fontSize: 11, padding: '2px 6px', borderRadius: 4, background: '#dcfce7', color: '#166534', fontWeight: 700 }}>WA</span>
                      )}
                      {c.instagramConnected && (
                        <span style={{ fontSize: 11, padding: '2px 6px', borderRadius: 4, background: '#fce7f3', color: '#9d174d', fontWeight: 700 }}>IG</span>
                      )}
                      {!c.whatsappConnected && !c.instagramConnected && (
                        <span style={{ fontSize: 11, color: '#94a3b8' }}>—</span>
                      )}
                    </div>
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontSize: 14, color: '#475569', fontWeight: 600 }}>
                    {c.monthlyMessages}
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontSize: 14, color: '#475569', fontWeight: 600 }}>
                    {c.monthlyReservations}
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontSize: 13, color: '#94a3b8' }}>
                    {new Date(c.createdAt).toLocaleDateString('tr-TR')}
                  </td>
                  <td style={{ padding: '8px 16px', borderBottom: '1px solid #f1f5f9' }} onClick={e => e.stopPropagation()}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {(c.status === 'trial' || c.status === 'expired') && (
                        <button
                          onClick={e => quickAction(e, c.id, 'extend')}
                          disabled={actioning === c.id + 'extend'}
                          style={{ fontSize: 11, padding: '4px 8px', borderRadius: 6, background: '#fef3c7', color: '#92400e', border: 'none', cursor: 'pointer', fontWeight: 700, whiteSpace: 'nowrap' }}
                        >+7 gün</button>
                      )}
                      <button
                        onClick={e => quickAction(e, c.id, 'freeze')}
                        disabled={actioning === c.id + 'freeze'}
                        style={{
                          fontSize: 11, padding: '4px 8px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 700, whiteSpace: 'nowrap',
                          background: c.status === 'frozen' ? '#dcfce7' : '#fee2e2',
                          color: c.status === 'frozen' ? '#166534' : '#991b1b',
                        }}
                      >{c.status === 'frozen' ? 'Aktif Et' : 'Dondur'}</button>
                      <button
                        onClick={e => { e.stopPropagation(); navigate(`/admin/customers/${c.id}`); }}
                        style={{ fontSize: 11, padding: '4px 8px', borderRadius: 6, background: '#ede9fe', color: '#6d28d9', border: 'none', cursor: 'pointer', fontWeight: 700 }}
                      >Detay</button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={7} style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>Kayıt bulunamadı.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
